<template>
  <div id="myProduct">
    <!--导航栏-->
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      :fixed="true"
      :border="true"
      @click-left="onClickLeft"
      ><template #right>
        <van-badge content="" v-if="type.includes('purchase')">
          <div @click="toOrdering">清单</div></van-badge
        >
        <van-icon v-else name="replay" size="18" @click="refresh" />
      </template>
    </van-nav-bar>
    <transition name="router-slider" mode="out-in">
      <router-view style="padding-top: 46px"></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return { title: "商品管理", type: "" };
  },
  created() {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      console.log(from.fullPath, "来源path", to);
      if (
        from.fullPath &&
        from.fullPath !== "/" &&
        from.fullPath !== "/qrcodeScan" &&
        !from.fullPath.includes("/productDetail") &&
        !from.fullPath.includes("/analysis/orderList/")
      ) {
        vm.previousRoute = from;
      }
    });
  },
  watch: {
    $route: {
      handler(to, from) {
        if (
          to.path.includes("/product/category") &&
          to.query &&
          to.query.type &&
          to.query.type === "edit"
        ) {
          this.title = "商品档案";
        } else {
          this.title = to.meta.title;
        }
        if (!to.path.includes("/product/category")) {
          this.previousRoute = from;
        }

        this.type = to.query.type || "";
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.handlerPath();
  },
  methods: {
    refresh() {
      location.reload();
    },
    hasNoBack() {
      if (
        !this.$router.history.index ||
        this.$router.history.index < 0 ||
        !!this.$router.history.stack ||
        this.$router.history.index >= this.$router.history.stack.length
      ) {
        return true;
      }
      if (
        !this.$router.history ||
        !this.$router.history.current ||
        !this.$router.history.current.fullPath
      ) {
        return true;
      }
      const noBackList = [
        "/qrcodeScan",
        "/productDetail",
        "/analysis/orderList/",
      ];
      console.log(
        noBackList.some((el) =>
          this.$router.history.current.fullPath.includes(el)
        )
      );
      if (
        noBackList.some((el) =>
          this.$router.history.current.fullPath.includes(el)
        )
      ) {
        return true;
      }
      return false;
    },
    onClickLeft() {
      debugger;
      console.log(this.$route, "当前path");
      let routeToPath = "";
      const validQuery = {};
      if (this.$route.query && Object.keys(this.$route.query).length > 0) {
        Object.keys(this.$route.query).forEach((key) => {
          validQuery[key] = this.$route.query[key];
        });
      }
      localStorage.setItem("addScanText", "");
      if (this.$route.path === "/product/add") {
        routeToPath = "/dashboard/application";
      }
      if (this.$route.path === "/product/productManagement") {
        routeToPath = "/dashboard/home";
      }

      if (routeToPath) {
        // 使用Vue Router的query参数形式，而不是字符串拼接
        this.$router.push({
          path: routeToPath,
          query: validQuery,
        });
        return;
      }
      if (
        this.$route.path.includes("/product/category") ||
        this.$route.path.includes("/product/modify") ||
        this.$route.path.includes("/productDetail")
      ) {
        if (
          this.previousRoute &&
          this.previousRoute.path !== this.$route.path
        ) {
          let path = this.previousRoute.path;
          let query = Object.assign({}, this.previousRoute.query, validQuery);
          this.$router.push({ path, query });
        } else {
          if (this.hasNoBack()) {
            this.$router.push("/dashboard/home");
            return;
          }
          (this.$router.back && this.$router.back()) ||
            this.$router.push("/dashboard/home");
        }
        return;
      }
      if (this.$route.meta.prev) {
        routeToPath = this.$route.meta.prev;
        // 使用Vue Router的query参数形式
        this.$router.replace({
          path: routeToPath,
          query: validQuery,
        });
        return;
      }
      console.log(this.$route.history);
      if (this.hasNoBack(this.$route.path))
        (this.$router.back && this.$router.back()) ||
          this.$router.push("/dashboard/home");
    },
    handlerPath() {
      if (
        this.previousRoute &&
        this.previousRoute.path.includes("purchase") &&
        !this.previousRoute.path.includes("query")
      ) {
        return {
          path: this.previousRoute.path,
          query: this.previousRoute.query,
        };
      } else {
        return {};
      }
    },
    toOrdering() {
      let path = "";
      if (this.type.includes("Order")) {
        path = "/purchase/orderAdd";
      } else if (this.type.includes("Return")) {
        path = "/purchase/returnAdd";
      } else if (this.type.includes("Receive")) {
        path = "/purchase/receiveAdd";
      }
      const param = this.handlerPath();
      const params = Object.assign(
        {},
        {
          path: path,
          query: { type: this.type },
        },
        param
      );
      this.$router.push(params);
    },
  },
};
</script>
<style scoped lang="less">
.van-nav-bar--fixed {
  position: fixed !important;
}
</style>
